module.exports = __webpack_public_path__ + "img/123.9.7fb1aa01.png";